import gql from "graphql-tag";

export const ACCEPT_TERM = gql`
  mutation upsert_terms_of_services_accept_one(
    $id: uuid
    $is_read: Boolean
    $is_accepted: Boolean
  ) {
    insert_terms_of_services_read_or_accepted_one(
      object: {
        terms_of_services_id: $id
        is_read: $is_read
        is_accepted: $is_accepted
      }
      on_conflict: {
        constraint: terms_of_services_accept_user_id_terms_of_services_id_key
        update_columns: [is_read, is_accepted]
      }
    ) {
      id
    }
  }
`;
